import './tooltip.scss'
import { observer } from 'mobx-react'
import type { FC } from 'react'
import { IconButton } from '@/common/components/iconButton/IconButton'
import { tooltipStore } from '@/common/components/tooltip/tooltip.store'
import { useInitialData } from '@/common/hooks/useInitialData'

export interface TooltipProps {
    text?: string
}

export const Tooltip: FC<TooltipProps> = observer(() => {
    const { isTooltipVisible } = tooltipStore
    // will need to remove later when this is shared
    const { promptLabel = '', noOfDays = 0 } = useInitialData()?.header?.preferredCinemaPrompt ?? {}

    if (!promptLabel || !isTooltipVisible) return null
    return (
        <div className="tooltip-container">
            <div className="tooltip-title">{promptLabel || ''}</div>
            <IconButton
                iconName="cross"
                className="tooltip-close-button"
                onClick={() => tooltipStore.hideTooltip(noOfDays)}
            />
        </div>
    )
})
